document.addEventListener("wpcf7mailsent", function (event) {
  const tracking = window.tei_program_tracking

  if (!tracking?.connectedFormId) {
    return
  }

  const response = event.detail?.apiResponse
  const submittedFormId = Number(
    response?.contact_form_id ?? event.detail?.contactFormId,
  )
  const connectedFormId = Number(tracking.connectedFormId)

  if (!submittedFormId || submittedFormId !== connectedFormId) {
    return
  }

  const formRoot =
    event.target?.closest?.(".wpcf7") ??
    event.target?.closest?.("form") ??
    event.target

  if (
    formRoot?.closest?.(".form-newsletter") ||
    formRoot?.closest?.(".newsletter-signup") ||
    !formRoot?.closest?.(".program-signup-form")
  ) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "liitu_programmiga",
  })
})
